export const inputStyle = {
  style: {
    marginBottom: '8px',
  },
  inputProps: {
    style: {
      fontSize: '14px',
      fontWeight: 400,
      padding: '6px 8px 5px 8px',
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
    }
  },
  InputLabelProps: {
    style: {
      fontSize: '14px',
    }
  },
}

export const subtitleStyle = {
  style: {
    fontSize: '11px',
    fontWeight: 'bold',
    marginTop: '12px',
    marginBottom: '8px',
  }
}

export default {
  inputStyle,
  subtitleStyle,
}